import { GEO } from '@/const/cookies';
import type React from 'react';
import { createContext } from 'react';
import { useCookies } from 'react-cookie';

type Lookup = { country: string; region: string; city: string };

export const GeoLookupContext = createContext<null | Lookup>(null);

interface GeoLookupProviderProps {
  children: React.ReactNode;
}

const GeoLookupProvider: React.FC<GeoLookupProviderProps> = ({ children }) => {
  const [cookies] = useCookies([GEO]);

  const lookup: Lookup = cookies[GEO] || null;
  return <GeoLookupContext.Provider value={lookup}>{children}</GeoLookupContext.Provider>;
};

export default GeoLookupProvider;
